import { bool, number } from "prop-types";
import { observer } from "mobx-react";
import { useEstimateEditorSettings, useEstimateEditorStore } from "@tools";
import { useVersioning } from "./useVersioning";
import { SortableListV2 } from "@components";
import { Grid } from "@material-ui/core";
import { NewVersionButton, VersionButton } from "./components";
import classnames from "classnames";

export const Versioning = observer(({
  compact=false,
  jiraVersion = null,
}) => {
  const { hasEditorPrivileges, isProposal } = useEstimateEditorSettings();
  const { visibilityMode, currentVersion } = useEstimateEditorStore();
  const {
    versions,
    editable,
    clickable,
    removable,
    hideable,
    isDragged,
    setDragged,
    handleVersionReorder,
  } = useVersioning();

  if(!hasEditorPrivileges && versions?.length <= 1)
    return null;
  
  return (
    <Grid
      item container
      className={classnames(compact ? "overflow-hidden -m-1 p-1" : "my-4")}
    >
      <SortableListV2
        list={versions}
        group="versions"
        onDragStart={() => setDragged(true)}
        onDragEnd={() => setDragged(false)}
        onDragCancel={() => setDragged(false)}
        onListReorder={handleVersionReorder}
        disabled={!hasEditorPrivileges || compact}
        itemIdKey="key"
        childIdKey="identifier"
        className={classnames(!compact && "flex-wrap") }
        itemContainerProps={{ className: "w-max" }}
      >
        {versions.map(({ key, name, locked, visible }) => (
          (!jiraVersion || jiraVersion.toString() === key.toString() ) && (
            <VersionButton
              key={key}
              identifier={key}
              name={name}
              selected={key === currentVersion}
              removable={removable}
              editable={editable}
              hideable={hideable}
              clickable={clickable}
              isDragged={isDragged}
              used={!!visible}
              locked={!!locked && !isProposal}
              editVisibility={visibilityMode}
              disableInteraction
            />
          )
        ))}
        {
          editable &&
          <NewVersionButton />
        }
      </SortableListV2>
    </Grid>
  );
});

Versioning.propTypes = {
  compact: bool,
  jiraVersion: number,
};
